var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0025 0H9.9975C4.48375 0 0 4.70925 0 10.5C0 12.7969 0.705 14.9257 1.90375 16.6543L0.6575 20.5551L4.50125 19.2649C6.0825 20.3647 7.96875 21 10.0025 21C15.5162 21 20 16.2894 20 10.5C20 4.71056 15.5162 0 10.0025 0Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8212 14.8274C15.5799 15.5427 14.6224 16.1359 13.8587 16.3092C13.3362 16.426 12.6537 16.5192 10.3562 15.5191C7.41744 14.2407 5.52494 11.1051 5.37744 10.9017C5.23619 10.6982 4.18994 9.24137 4.18994 7.73462C4.18994 6.22787 4.91869 5.49418 5.21244 5.17918C5.45369 4.92062 5.85244 4.80249 6.23494 4.80249C6.35869 4.80249 6.46994 4.80905 6.56994 4.8143C6.86369 4.82743 7.01119 4.8458 7.20494 5.33274C7.44619 5.94305 8.03369 7.4498 8.10369 7.60468C8.17494 7.75955 8.24619 7.96955 8.14619 8.17299C8.05244 8.38299 7.96994 8.47618 7.82244 8.65468C7.67494 8.83318 7.53494 8.96968 7.38744 9.1613C7.25244 9.32799 7.09994 9.50649 7.26994 9.81493C7.43994 10.1168 8.02744 11.1235 8.89244 11.932C10.0087 12.9754 10.9137 13.3088 11.2374 13.4506C11.4787 13.5556 11.7662 13.5306 11.9424 13.3337C12.1662 13.0804 12.4424 12.6604 12.7237 12.247C12.9237 11.9504 13.1762 11.9136 13.4412 12.0186C13.7112 12.1171 15.1399 12.8586 15.4337 13.0122C15.7274 13.1671 15.9212 13.2406 15.9924 13.3705C16.0624 13.5004 16.0624 14.1107 15.8212 14.8274Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons1);
export default __webpack_public_path__ + "static/media/icons1.119d9942127a38dc09f47198db99468d.svg";
export { ForwardRef as ReactComponent };